import { ref } from 'vue'

interface Notification {
  id: number
  type: 'success' | 'error' | 'warning'
  title: string
  message: string
}

const notifications = ref<Notification[]>([])
let nextId = 0

export function useNotification() {
  const showNotification = (type: 'success' | 'error' | 'warning', title: string, message: string) => {
    const id = nextId++
    notifications.value.push({ id, type, title, message })
    
    // Remover la notificación después de 5 segundos
    setTimeout(() => {
      removeNotification(id)
    }, 7000)
  }

  const removeNotification = (id: number) => {
    notifications.value = notifications.value.filter(n => n.id !== id)
  }

  return {
    notifications,
    showNotification,
    removeNotification
  }
} 